var panasonic_N2QAYB000239 = {
    name: "N2QAYB000239",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,170,237,86,136],
        },
        {
            function: "KEY_TV",
            name: "KEY_TV",
            icon: "KEY_TV",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,246,255,235,221,104,128],
        },
        {
            // function: "KEY_AV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,191,111,162],
        },
        {
            function: "Aspect",
            name: "Aspect",
            icon: "Aspect",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,127,85,173,173,136],
        },
        {
            function: "Link",
            name: "Link",
            icon: "Link",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,223,122,222,174,32],
        },
        {
            function: "KEY_OPTION",
            name: "KEY_OPTION",
            icon: "KEY_OPTION",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,223,87,109,91,136],
        },
        {
            function: "SDCard",
            name: "SDCard",
            icon: "SDCard",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,223,91,109,238,32],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,213,221,90,32],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,118,171,182,32],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,221,219,168,128],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,110,214,234,32],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,174,234,234,32],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,87,106,186,136],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,221,187,168,128],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,237,221,168,128],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,109,118,216,128],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,213,250,168,128],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,234,222,170,32],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,234,238,170,32],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,117,107,170,136],
        },
        {
            function: "KEY_TEXT",
            name: "KEY_TEXT",
            icon: "KEY_TEXT",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,254,191,223,162],
        },
        {
            function: "Sttl",
            name: "Sttl",
            icon: "Sttl",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,254,223,239,162],
        },
        {
            function: "Index",
            name: "Index",
            icon: "Index",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,255,223,119,162],
        },
        {
            function: "Hold",
            name: "Hold",
            icon: "Hold",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,254,239,247,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,223,238,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,239,123,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,239,187,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,119,174,232,128],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,111,219,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,183,182,232,128],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,183,214,232,128],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,91,213,186,32],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,175,235,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,215,186,232,128],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,254,235,221,104,128],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,107,237,104,128],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,181,219,90,32],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,239,246,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,247,125,162],
        },
        {
            function: "VcrProgDown",
            name: "VcrProgDown",
            icon: "VcrProgDown",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,254,218,237,218,32],
        },
        {
            function: "VcrProgUp",
            name: "VcrProgUp",
            icon: "VcrProgUp",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,181,247,104,128],
        },
        {
            function: "VcrSkipBack",
            name: "VcrSkipBack",
            icon: "VcrSkipBack",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,127,187,162],
        },
        {
            function: "VcrSkipFwd",
            name: "VcrSkipFwd",
            icon: "VcrSkipFwd",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,254,191,174,232,128],
        },
        {
            function: "VcrRewind",
            name: "VcrRewind",
            icon: "VcrRewind",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,254,238,221,106,32],
        },
        {
            function: "VcrFFwd",
            name: "VcrFFwd",
            icon: "VcrFFwd",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,110,237,106,32],
        },
        {
            function: "VcrStop",
            name: "VcrStop",
            icon: "VcrStop",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,255,238,136],
        },
        {
            function: "VcrPause",
            name: "VcrPause",
            icon: "VcrPause",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,95,214,232,128],
        },
        {
            function: "VcrPlay",
            name: "VcrPlay",
            icon: "VcrPlay",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,111,218,232,128],
        },
        {
            function: "VcrPower",
            name: "VcrPower",
            icon: "VcrPower",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,254,213,118,182,136],
        },
        {
            function: "VcrRec",
            name: "VcrRec",
            icon: "VcrRec",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,187,255,223,235,162],
        },
        {
            function: "KEY_DVD",
            name: "KEY_DVD",
            icon: "KEY_DVD",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,173,255,239,245,104,128],
        },
        {
            function: "KEY_N",
            name: "KEY_N",
            icon: "KEY_N",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,255,95,215,162],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,247,253,235,189,104,128],
        },
        {
            function: "DirectTvRec",
            name: "DirectTvRec",
            icon: "DirectTvRec",
            command: [100,0,4,241,1,110,1,241,1,215,4,243,13,98,6,223,1,172,32,55,255,191,245,223,119,191,226],
        },
        {
            function: "PC",
            name: "PC",
            icon: "PC",
            command: [100,0,4,43,2,39,1,40,2,170,4,245,13,110,6,35,2,172,32,55,255,191,247,254,213,118,170,136],
        },
        {
            function: "VIERATOOLS",
            name: "VIERATOOLS",
            icon: "VIERATOOLS",
            command: [100,0,4,44,2,35,1,39,2,170,4,247,13,115,6,67,2,172,32,55,255,191,247,253,86,170,173,98],
        },
        {
            function: "VIERALINK",
            name: "VIERALINK",
            icon: "VIERALINK",
            command: [100,0,4,46,2,33,1,47,2,175,4,255,13,106,6,61,2,172,32,55,255,191,245,223,122,222,174,32],
        },
        {
            function: "VIERASDCARD",
            name: "VIERASDCARD",
            icon: "VIERASDCARD",
            command: [100,0,4,41,2,37,1,50,2,170,4,10,14,105,6,71,2,172,32,55,255,191,245,223,91,109,238,32],
        },
    ]
}
export default panasonic_N2QAYB000239